import { FC } from 'react';
import styles from './TrustedShopsRating.module.scss';

const TrustedShopsRating: FC = () => {
  const handleBoxClick = (): void => {
    const trustedShopsReviewsElt = document.getElementById('TrustedShopsReviews');
    trustedShopsReviewsElt?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  return (
    <div className={styles.wrapper} onClick={handleBoxClick}>
      <div className={styles.box}>
        <div className={styles.image}></div>
        <div className={styles.title}>Trusted shops guarantee</div>
      </div>
      <div className={styles.box}>
        <div className={styles.starList}>
          <div className={styles.star} />
          <div className={styles.star} />
          <div className={styles.star} />
          <div className={styles.star} />
          <div className={styles.star} />
        </div>
      </div>
    </div>
  );
};

export default TrustedShopsRating;
